import VisFilterConverter from './VisFilterConverter'

define([], function() {
	return VisFilterConverter;
})